import React, { useState, useEffect } from "react";
import {
  crossIcon,
  crossIconRoundWhite,
  searchIcon,
} from "../../constants/Images";
import { PricingGrid } from "../../constants/Pricing";

import { Modal, ModalBody } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCustomers,
  cancelSubscription,
} from "../../redux/actions/customerAction";
import { Link } from "react-router-dom";
import Blinking from "../../Loaders/Blinking";
import { formatDate, isFutureDate } from "../../helpers/genericHelpers";

export default function Customers() {
  const {
    isCustomersFetching,
    customers_offset,
    customers_limit,
    customers,
    isCustomersFetched,
    isCancellingSubscription,
  } = useSelector((state) => state.customersData);
  const [customersData, setCustomersData] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [recordsLimit, setRecordsLimit] = useState(null);
  const [hovered, setHovered] = useState(null);
  const toggleHover = (index) => setHovered(index);

  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const toggle = (stripe_subscription_id) => {
    setModal(!modal);
    const currentCustomer = {
      stripe_subscription_id,
    };
    setSelectedCustomer(currentCustomer);
  };

  const handleCancelSubscription = (stripe_subscription_id) => {
    const data = { stripe_subscription_id };
    dispatch(cancelSubscription(data));
  };

  const handleCancelLicence = () => {
    setModal(false);
    handleCancelSubscription(selectedCustomer.stripe_subscription_id);
  };

  useEffect(() => {
    if (customers_offset === 0) {
      dispatch(fetchCustomers(customers_offset, customers_limit));
    } else {
      dispatch(
        fetchCustomers(customers_offset + customers_limit, customers_limit)
      );
    }
  }, []);

  useEffect(() => {
    setCustomersData(customers);
    let PricingData = PricingGrid.data;
    PricingData = PricingData.filter((data) => {
      if (data.id !== 1) {
        return data;
      }
    });
    let newcustomers = [...customersData];
    for (let pricing of PricingData) {
      for (let product of pricing.products) {
        for (let plan of product.plans) {
          newcustomers.forEach((el) => {
            if (el.plan_id === plan.code) {
              el.planType = plan.interval;
              el.planDescription = product.name;
              el.planName = pricing.name;
            }
          });
        }
      }
    }
    setFilteredCustomers(customersData);
  }, [customersData, customers]);

  const onSearchInputChange = (e) => {
    e.persist();
    let value = e.target.value;
    let filteredCustomers = [];
    if (value.length === 0) {
      filteredCustomers = [...customersData];
      setFilteredCustomers(filteredCustomers);
      setRecordsLimit(null);
      return;
    }
    filteredCustomers = customersData.filter((customer) => {
      if (
        customer.name.toLowerCase().includes(value.toLowerCase()) ||
        customer.email.toLowerCase().includes(value.toLowerCase()) ||
        customer.planName.toLowerCase().includes(value.toLowerCase()) ||
        customer.planDescription.toLowerCase().includes(value.toLowerCase())
      ) {
        return customer;
      }
    });
    setFilteredCustomers(filteredCustomers);
    setRecordsLimit(filteredCustomers.length);
  };

  const handleFetchMoreCustomers = () => {
    dispatch(
      fetchCustomers(customers_offset + customers_limit, customers_limit)
    );
  };

  return (
    <>
    {
      isCustomersFetched ? <>
      {
        customers.length !== 0 ? <>
        {" "}
        <div className="clearfix customerSearchArea">
          <div className="clearfix profileArea">
            <form
              action=""
              className="form invitePeopleForm customerSearchForm"
            >
              <div className="row">
                <div className="col-3 hide-col pr-2">
                  <div className="form-group mt-0 mb-0">
                    <div className="inputGrabber">
                      <span className="input_icon">
                        <img src={searchIcon} alt="" className="" />
                      </span>
                      <input
                        type="email"
                        className="form-control form-control-gray"
                        placeholder="Enter keyword to search"
                        onChange={onSearchInputChange}
                      />
                      {recordsLimit !== null ? (
                        <p className="recordsFound">
                          {recordsLimit} matching records found!
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="col-2 pl-0">
                  <div className="form-group mt-0 mb-0">
                    <Link
                      to="/plans"
                      className="submit-btn submit-primary mt-0 addCustBtn"
                    >
                      + Add Customer
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="adminCard">
          <Modal
            isOpen={modal}
            toggle={toggle}
            fade={false}
            centered
            className="modifyLicenceModal"
          >
            <ModalBody>
              <div className="text-right">
                <img
                  src={crossIcon}
                  alt="close"
                  onClick={toggle}
                  className="c-pointer"
                />
              </div>
              <h3 className="modal_title text-center">
                Are you sure want to cancel the subscription?
              </h3>
              <div className="row py-3 gutters-5 mdlrow">
                <div className="col-6">
                  <button
                    type="button"
                    className="rs_sm_btn rs_btn rs_primary_bg text-uppercase w-100"
                    onClick={handleCancelLicence}
                  >
                    Yes
                  </button>
                </div>
                <div className="col-6">
                  <span
                    className="rs_sm_btn rs_btn rs_danger_bg text-uppercase w-100 btn28lineHeight text-center"
                    onClick={() => setModal(false)}
                  >
                    No
                  </span>
                </div>
              </div>
            </ModalBody>
          </Modal>
          <div className="table-responsive userlist-table customers-table pl-5">
            <table className="table">
              <thead>
                <tr style={{ height: "57px" }}>
                  <th
                    scope="col"
                    className="rw-pl-50"
                    style={{ width: "280px" }}
                  >
                    Customer Details
                  </th>
                  <th scope="col" style={{ width: "300px" }}>
                    License Assigned
                  </th>
                  <th scope="col"> Start Date</th>
                  <th
                    scope="col"
                    style={{ width: "120px", paddingLeft: "27px" }}
                  >
                    Status
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {filteredCustomers &&
                  filteredCustomers.map((customer, index) => {
                    return (
                      <tr
                        className={hovered === index ? "highlighted" : ""}
                        onMouseEnter={() => toggleHover(index)}
                        onMouseLeave={() => toggleHover(null)}
                        key={customer.id}
                      >
                        <td className="rw-pl-50">
                          <span className="d-block">{customer.name}</span>
                          <span>{customer.email}</span>
                        </td>
                        <td>
                          <b
                            className="d-block text-uppercase"
                            style={{ fontSize: "10px" }}
                          >
                            {customer.plan_id}{" "}
                            <span className="text-capitalize">{`(${customer.planType}ly)`}</span>
                          </b>
                          <span className="d-block">{customer.planName}</span>
                          <span className="d-block">
                            {customer.planDescription}
                          </span>
                        </td>
                        <td>
                          <span>{formatDate(customer.created_at)}</span>
                        </td>
                        <td>
                          <span
                            className={
                              `rs_badge rs_badge_outline ` +
                              (customer.cancel_at ? "red" : "green")
                            }
                          >
                            {customer.cancel_at
                              ? isFutureDate(customer.cancel_at)
                                ? "Cancels on"
                                : "Cancelled"
                              : "Running"}
                          </span>
                        </td>

                        <td>
                          {customer.cancel_at ? (
                            <i>{formatDate(customer.cancel_at)}</i>
                          ) : (
                            <>
                              <Link
                                className="rs_sm_btn rs_btn rs_primary_bg text-uppercase mr-2 btn28lineHeight"
                                to={`/plans?method=${customer.stripe_subscription_id}&&name=${customer.planName}&&subscription=${customer.planDescription}&&type=${customer.planType}&&plan_id=${customer.plan_id}`}
                                // onClick={() =>
                                //   toggle(
                                //     customer.stripe_subscription_id,
                                //     customer.created_at,
                                //     customer.plan_id,
                                //     customer.email
                                //   )
                                // }
                              >
                                <span>Modify Plan</span>
                              </Link>
                              <button
                                className="rs_sm_btn rs_btn rs_danger_bg text-uppercase"
                                onClick={() =>
                                  toggle(customer.stripe_subscription_id)
                                }
                              >
                                <img
                                  src={crossIconRoundWhite}
                                  alt=""
                                  className="rs_btn_icon"
                                />
                                
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="5" className="text-center">
                    {customers.length >= 15 ? <button
                      className="rs_sm_btn rs_btn text-uppercase mr-2"
                      onClick={handleFetchMoreCustomers}
                    >
                      <span>
                        {isCustomersFetching ? "Loading..." : "Load more"}
                      </span>
                    </button> : null}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </> : <div className="adminCard p-4 no__data__card">
              <h3>You have not added any customers yet</h3>
              <Link className="rs_sm_btn rs_btn rs_primary_bg text-uppercase mt-3" to="/plans">+ Add Customer</Link>
          </div>
      }
      </> : null
    }
    </>
  );
}
